import React, { useState } from "react";
import { Box } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import { GeoAccuracyKpi } from "./GeoAccuracyKpi";
import { UsersKpi } from "./UsersKpi";
import { AgricultureKpi } from "./AgricultureKpi";
import { ClaimsKpi } from "./ClaimsKpi";

export const KpiDashboard = () => {
  const [kpiTabIndex, setKpiTabIndex] = useState(0);

  const handleTabChange = (event, newTabIndexValue) => {
    setKpiTabIndex(newTabIndexValue);
  };

  return (
    <>
      <Box mt={2}>
        <Box mb={1} mt={1}>
          <AppBar position="static" color="default" elevation={1}>
            <Tabs value={kpiTabIndex} onChange={handleTabChange}>
              <Tab label="Geo Accuracy" />
              <Tab label="Users" />
              <Tab label="Agriculture" />
              <Tab label="Claims" />
            </Tabs>
          </AppBar>
        </Box>

        {kpiTabIndex === 0 && <GeoAccuracyKpi></GeoAccuracyKpi>}
        {kpiTabIndex === 1 && <UsersKpi></UsersKpi>}
        {kpiTabIndex === 2 && <AgricultureKpi></AgricultureKpi>}
        {kpiTabIndex === 3 && <ClaimsKpi></ClaimsKpi>}
      </Box>
    </>
  );
};
